import { useTranslation } from 'next-i18next'
import { SyntheticEvent } from 'react'

import ROUTES from '~/shared/constants/routes.const'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { STACK_N_LOAD } from '~/statistics/constants'
import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'

import TimeSpent from '../TimeSpent'
import SummaryHeader from '../SummaryHeader'

interface Props {
  showContent: boolean
  onClick: () => void
  timeSpent: number
}

export default function StackNLoadSummary({ showContent, onClick, timeSpent }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const { days, hours, minutes } = convertMsToDayHourMinute(timeSpent)

  const onClickTitle = (evt: SyntheticEvent): void => {
    evt.stopPropagation()
    statisticsAnalytics.logProductTileClick({ title: STACK_N_LOAD })
  }

  return (
    <button className="w-full space-y-3" onClick={onClick}>
      <SummaryHeader
        cardTitle={STACK_N_LOAD}
        iconAltText={STACK_N_LOAD}
        iconSrcKey="scoreboard/stack-n-load.png"
        onClickTitle={onClickTitle}
        productHref={ROUTES.STACKNLOAD}
        productSubtitle={t('fractions')}
        productTitle={t('game')}
        showContent={showContent}
      />
      <div className="font-medium flex flex-start">
        <TimeSpent days={days} hours={hours} minutes={minutes} />
      </div>
    </button>
  )
}
